export interface PaneCensusRoot {
  querySelector<T = PaneCensusHost>(selector: string): T | null;
}

export interface PaneCensusHost {
  dataset: { paneCount?: string };
}

export interface PaneCensusMutation {
  target: PaneCensusHost;
  attributeName?: string | null;
}

export interface PaneCensusObserver {
  observe(target: unknown, options: {
    subtree: boolean;
    childList: boolean;
    attributes: boolean;
    attributeFilter: string[];
  }): void;
  disconnect(): void;
}

export type PaneCensusObserverFactory = (callback: (records: PaneCensusMutation[]) => void) => PaneCensusObserver;
export type PaneCensusCallback = (count: number | null) => void;

const browserObserver: PaneCensusObserverFactory = (callback) => new MutationObserver((records) => {
  callback(records.map((record) => ({
    target: record.target as unknown as PaneCensusHost,
    attributeName: record.attributeName,
  })));
});

export function observeMountedPaneCount(
  root: PaneCensusRoot,
  onCount: (count: number) => void,
  makeObserver: PaneCensusObserverFactory = browserObserver,
  onCallback: PaneCensusCallback = () => {},
): () => void {
  const read = (host = root.querySelector<PaneCensusHost>(".scvd .host")) => {
    const measured = Number(host?.dataset.paneCount ?? 0);
    const count = Number.isFinite(measured) && measured > 0 ? measured : null;
    if (count !== null) onCount(count);
    return count;
  };
  const observer = makeObserver((records) => {
    const mutation = records.find((record) => record.attributeName === "data-pane-count");
    onCallback(read(mutation?.target));
  });
  observer.observe(root, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ["data-pane-count"],
  });
  read();
  return () => observer.disconnect();
}
